import cookie from 'js-cookie';

class Cookies {
  set(key, value) {
    cookie.set(key, value);
  }

  setWithExpires(key, value, expires) {
    cookie.set(key, value, { expires });
  }

  remove(key) {
    cookie.remove(key);
  }

  get(key, request) {
    if (request) {
      return this._getServer(key, request);
    }
    return this._getClient(key);
  }

  _getClient(key) {
    return cookie.get(key);
  }

  _getServer(key, request) {
    const { cookies } = request;
    if (cookies) {
      return cookies[key];
    }
    return undefined;
  }
}

export default new Cookies();
